import { on } from '@ngrx/store';
import { omit } from 'lodash-es';

import { createImmutableReducer } from '../../base/store/helpers';
import { BetslipV1Pick } from '../../core/picks/betslip-v1-pick';
import { BetslipV2Pick } from '../../core/picks/betslip-v2-pick';
import { GroupPickId } from '../../core/picks/pick-id';
import BetslipPickActions from '../picks/actions';
import { pickSelectionHandlers } from '../picks/reducer';
import { removeOrderedTypePicks } from '../picks/services/type-pick.utils';
import { BetslipTeaserActions } from './actions';
import { ITeaserBetState, defaultTeaserBetPickState, defaultTeaserBetState } from './state';

export const teaserBetReducer = createImmutableReducer(
    defaultTeaserBetState,
    ...pickSelectionHandlers<ITeaserBetState>(),
    on(BetslipTeaserActions.removePick, (state, action) => {
        delete state.picks[action.pickId];

        return state;
    }),
    on(BetslipTeaserActions.removePicks, (state, action) => {
        const newState = { ...state, picks: { ...state.picks } };
        const pickIds = Object.keys(newState.picks).filter((pickId) => action.pickIds.includes(pickId));

        if (pickIds.length > 0) {
            pickIds.forEach((id) => {
                newState.picks = omit(newState.picks, id);
            });
        }

        return newState;
    }),
    on(BetslipTeaserActions.addUpdatePick, (state, action) => {
        const pickId = action.payload.pick.id.toString();
        let pick = state.picks[pickId] || defaultTeaserBetPickState;
        let eventId =
            action.payload.pick instanceof BetslipV2Pick ? action.payload.pick.fixture.fixtureId : (action.payload.pick as BetslipV1Pick).event.id;
        pick = {
            ...pick,
            id: pickId,
            selectedOption: action.payload.selectedOption,
            eventId: eventId,
            order: action.payload.order ?? pick.order,
        };

        state.picks[action.payload.pick.id.toString()] = pick;

        return state;
    }),
    on(BetslipTeaserActions.setTeaserBetStake, (state, action) => {
        state.stake = action.stake;
        state.actualStake = action.stakeStr;

        return state;
    }),
    on(BetslipTeaserActions.setTeasePicks, (state, action) => {
        state.selectedPoints = action.keypoint;

        return state;
    }),
    on(BetslipTeaserActions.updateTeaserPrices, (state, action) => {
        state.teaserPrice = action.odds;
        state.priceVersionId = action.priceVersionId;
        const picks = Object.values(state.picks);
        picks
            .filter((pick) => !!action.picks[pick.id])
            .forEach((pick) => {
                pick.oldPoints = action.picks[pick.id].oldPoints;
                pick.newPoints = action.picks[pick.id].newPoints;
            });

        return state;
    }),
    on(BetslipTeaserActions.setPlaceBlocking, (state, action) => {
        state.placeBlocking = action.placeBlocking;

        return state;
    }),

    on(BetslipTeaserActions.acceptCurrentPrice, (state, action) => {
        const newState = { ...state, picks: { ...state.picks } };
        const pickId = action.pickId.toString();

        const teaserPick = { ...state.picks[pickId] };

        newState.picks[pickId] = teaserPick;

        return newState;
    }),

    on(BetslipTeaserActions.updateBalancePick, (state, action) => {
        const pickId = action.payload.pickId;
        let pick = state.picks[pickId] || defaultTeaserBetPickState;

        pick = {
            ...pick,
            isNonBalancedPick: action.payload.isNonBalanceMarket,
        };

        state.picks[action.payload.pickId] = pick;

        return state;
    }),

    on(BetslipTeaserActions.setTeaserBetRewardToken, (state, action) => {
        state.rewardTokenId = action.rewardTokenId;

        return state;
    }),

    on(BetslipPickActions.togglePick, (state, action) => {
        const pick = { ...state.picks[action.pickId.toString()] };
        pick.isSelected = !pick.isSelected;

        return state;
    }),
    on(BetslipTeaserActions.togglePick, (state, action) => {
        const pick = state.picks[action.pickId];
        pick.isSelected = !pick.isSelected;

        return state;
    }),
    on(BetslipPickActions.toggleAllPicks, (state, action) => {
        const picks = Object.values(state.picks);
        picks.forEach((pick) => (pick.isSelected = action.select));

        return state;
    }),
    on(BetslipPickActions.removePick, (state, action) => {
        delete state.picks[action.pickId.toString()];

        return state;
    }),
    on(BetslipPickActions.replacePick, (state, action) => {
        const pickId = action.pickId.toString();

        if (!state.picks[pickId] || GroupPickId.isId(action.newPick.id)) {
            return state;
        }

        const newPick = state.picks[pickId];
        delete state.picks[pickId];
        state.picks[action.newPick.id.toString()] = newPick;

        return state;
    }),
    on(BetslipPickActions.removeTypePicks, (state, action) => {
        removeOrderedTypePicks(action.pickIds, state.picks);

        return state;
    }),
);
